"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1878],{

/***/ 15095:
/***/ (function(module) {



/*
 * Calculate the byte lengths for utf8 encoded strings.
 *
 * @param {String} str
 * @return {Number}
 */
module.exports = function byteLength (str) {
  var i, len;
  if (!str) return 0;
  str = str.toString();

  for (i = len = str.length; i--;) {
    var code = str[i].charCodeAt();
    if (0xDC00 <= code && code <= 0xDFFF) i--;
    if (0x7f < code && code <= 0x7ff) len++;
    else if (0x7ff < code && code <= 0xffff) len += 2;
  }

  return len;
};


/***/ }),

/***/ 86317:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.requestInfo = exports.debug = exports.parseText = exports.parseJSON = exports.parse = exports.onResponse = exports.handleResponse = exports.recv = exports.params = exports.json = exports.body = exports.query = exports.base = exports.accept = exports.auth = exports.header = exports.method = exports.init = exports.fetch = exports.createFetch = exports.createStack = exports.enhanceFetch = exports.enableRecv = undefined;

var _queryString = __webpack_require__(17563);

var _byteLength = __webpack_require__(15095);

var _byteLength2 = _interopRequireDefault(_byteLength);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var global = (1, eval)('this');

var stringifyQuery = function stringifyQuery(query) {
  return typeof query === 'string' ? query : (0, _queryString.stringify)(query);
};

var stringifyJSON = function stringifyJSON(json) {
  return typeof json === 'string' ? json : JSON.stringify(json);
};

var processResponse = function processResponse(response, handlers) {
  return handlers.reduce(function (promise, handler) {
    return promise.then(handler);
  }, Promise.resolve(response));
};

/**
 * Returns a new fetch function that knows how to execute
 * options.responseHandlers on the response.
 */
var enableRecv = exports.enableRecv = function enableRecv(fetch) {
  return function (input) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    return fetch(input, options).then(function (response) {
      var responseHandlers = options.responseHandlers;

      return responseHandlers && responseHandlers.length ? processResponse(response, responseHandlers) : response;
    });
  };
};

// Deprecated.
var enhanceFetch = exports.enhanceFetch = enableRecv;

var emptyStack = function emptyStack(fetch, input, options) {
  return fetch(input, options);
};

/**
 * Creates a middleware "stack" function using all arguments.
 * A "stack" is essentially a bunch of middleware composed into
 * a single middleware function. Since all middleware share the
 * same signature, stacks may further be combined to create more
 * stacks with different characteristics.
 */
var createStack = exports.createStack = function createStack() {
  for (var _len = arguments.length, middleware = Array(_len), _key = 0; _key < _len; _key++) {
    middleware[_key] = arguments[_key];
  }

  if (middleware.length === 0) return emptyStack;

  return middleware.reduceRight(function (inner, outer) {
    return function (fetch, outerInput, outerOptions) {
      return outer(function (innerInput, innerOptions) {
        return inner(fetch, innerInput, innerOptions);
      }, outerInput, outerOptions);
    };
  });
};

/**
 * Creates a fetch function using all arguments as middleware.
 * This function is a "stack" that uses the global fetch, so the
 * following two examples are equivalent:
 *
 *   const stack = createStack(middleware)
 *   stack(global.fetch, input, options)
 *
 *   const fetch = createFetch(middleware)
 *   fetch(input, options)
 *
 * Thus, createFetch essentially eliminates some boilerplate code
 * when you just want to use the global fetch function.
 */
var createFetch = exports.createFetch = function createFetch() {
  if (arguments.length === 0) return global.fetch;

  var stack = createStack.apply(undefined, arguments);

  return enableRecv(function (input) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    return stack(global.fetch, input, options);
  });
};

// Deprecated.
var mainFetch = enableRecv(global.fetch);
exports.fetch = mainFetch;

/**
 * Sets a property name and value in the options object.
 */

var init = exports.init = function init(propertyName, value) {
  return function (fetch, input) {
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    options[propertyName] = value;
    return fetch(input, options);
  };
};

/**
 * Sets the request method.
 */
var method = exports.method = function method(verb) {
  return init('method', verb);
};

var setHeader = function setHeader(options, name, value) {
  (options.headers || (options.headers = {}))[name] = value;
};

/**
 * Adds a header to the request.
 */
var header = exports.header = function header(name, value) {
  return function (fetch, input) {
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    setHeader(options, name, value);
    return fetch(input, options);
  };
};

/**
 * Adds an Authorization header to the request.
 */
var auth = exports.auth = function auth(value) {
  return header('Authorization', value);
};

/**
 * Adds an Accept header to the request.
 */
var accept = exports.accept = function accept(value) {
  return header('Accept', value);
};

/**
 * Adds the given string at the front of the request URL.
 */
var base = exports.base = function base(baseURL) {
  return function (fetch, input, options) {
    return fetch(baseURL + (input || ''), options);
  };
};

/**
 * Adds the given object to the query string in the request.
 */
var query = exports.query = function query(object) {
  var queryString = stringifyQuery(object);

  return function (fetch, input, options) {
    return fetch(input + (input.indexOf('?') === -1 ? '?' : '&') + queryString, options);
  };
};

/**
 * Adds the given content to the request.
 */
var body = exports.body = function body(content, contentType) {
  return function (fetch, input) {
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    options.body = content;

    if (content.length != null) setHeader(options, 'Content-Length', (0, _byteLength2.default)(content));

    if (contentType) setHeader(options, 'Content-Type', contentType);

    return fetch(input, options);
  };
};

/**
 * Adds an application/json payload to the request.
 */
var json = exports.json = function json(object) {
  return body(stringifyJSON(object), 'application/json');
};

/**
 * Adds the given object to the query string of GET/HEAD requests
 * and as a application/x-www-form-urlencoded payload on all others.
 */
var params = exports.params = function params(object) {
  var queryString = stringifyQuery(object);

  return function (fetch, input) {
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    var verb = (options.method || 'GET').toUpperCase();
    var middleware = verb === 'GET' || verb === 'HEAD' ? query(queryString) : body(queryString, 'application/x-www-form-urlencoded');

    return middleware(fetch, input, options);
  };
};

/**
 * A helper for creating middleware that handles a successful response.
 */
var recv = exports.recv = function recv(handler) {
  return function (fetch, input) {
    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

    (options.responseHandlers || (options.responseHandlers = [])).push(handler);
    return fetch(input, options);
  };
};

// Deprecated.
var handleResponse = exports.handleResponse = recv;
var onResponse = exports.onResponse = recv;

/**
 * Reads the response stream to completion, parses its content
 * using the given parser, and adds the result to response.body.
 */
var parse = exports.parse = function parse(parser) {
  var as = arguments.length <= 1 || arguments[1] === undefined ? 'body' : arguments[1];
  return recv(function (response) {
    if (as in response) return response[as];

    return response[parser]().then(function (body) {
      response[as] = body;
      return response;
    }, function (error) {
      throw new Error('parse(\'' + parser + '\') error: ' + error.stack);
    });
  });
};

// Deprecated.
var parseJSON = exports.parseJSON = function parseJSON() {
  var propertyName = arguments.length <= 0 || arguments[0] === undefined ? 'jsonData' : arguments[0];
  return parse('json', propertyName);
};

// Deprecated.
var parseText = exports.parseText = function parseText() {
  var propertyName = arguments.length <= 0 || arguments[0] === undefined ? 'textString' : arguments[0];
  return parse('text', propertyName);
};

/**
 * Adds a debug property to the response/error that contains
 * the input and options used in the request. Mainly useful in
 * testing and debugging.
 */
var debug = exports.debug = function debug() {
  return function (fetch, input, options) {
    return fetch(input, options).then(function (response) {
      response.debug = { input: input, options: options };
      return response;
    }, function () {
      var error = arguments.length <= 0 || arguments[0] === undefined ? new Error() : arguments[0];

      error.debug = { input: input, options: options };
      throw error;
    });
  };
};

// Deprecated.
var requestInfo = exports.requestInfo = function requestInfo() {
  return function (fetch, input, options) {
    return fetch(input, options).then(function (response) {
      response.requestInput = input;
      response.requestOptions = options;
      return response;
    }, function () {
      var error = arguments.length <= 0 || arguments[0] === undefined ? new Error() : arguments[0];

      error.requestInput = input;
      error.requestOptions = options;
      throw error;
    });
  };
};

/***/ }),

/***/ 96086:
/***/ (function(module) {


var assign = Object.assign.bind(Object);
module.exports = assign;
module.exports["default"] = module.exports;

//# sourceMappingURL=object-assign.js.map

/***/ }),

/***/ 91878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Session": function() { return /* binding */ Session; },
/* harmony export */   "promptGoogleOneTap": function() { return /* binding */ promptGoogleOneTap; }
/* harmony export */ });
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26198);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _opendoor_shared_fe_build_googleOneTap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11654);
/* harmony import */ var _opendoor_shared_fe_build_googleOneTap__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_googleOneTap__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35480);



var Session = new (_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_0___default())(_globals__WEBPACK_IMPORTED_MODULE_2__/* .XSRF_COOKIE_KEY */ .x0, _globals__WEBPACK_IMPORTED_MODULE_2__/* .RAILS_URL */ .oF);
var promptGoogleOneTap = function(analyticsName, success, trackEvent, trackError) {
    (0,_opendoor_shared_fe_build_googleOneTap__WEBPACK_IMPORTED_MODULE_1__.promptGoogleOneTap)({
        analyticsName: analyticsName,
        trackEvent: trackEvent,
        trackError: trackError,
        clientId: _globals__WEBPACK_IMPORTED_MODULE_2__/* .GOOGLE_CLIENT_ID */ .wL,
        onSuccess: function(response) {
            Session.register(undefined, undefined, undefined, undefined, response.credential).then(function() {
                return success();
            });
        }
    });
};


/***/ }),

/***/ 17563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var strictUriEncode = __webpack_require__(70610);
var objectAssign = __webpack_require__(96086);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ 26198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SessionApi = void 0;
var Cookies = __importStar(__webpack_require__(36808));
var http_client_1 = __webpack_require__(86317);
var ResponseError = /** @class */ (function (_super) {
    __extends(ResponseError, _super);
    function ResponseError(message, response) {
        var _this = _super.call(this, message) || this;
        _this.response = response;
        return _this;
    }
    return ResponseError;
}(Error));
var SessionApi = /** @class */ (function () {
    function SessionApi(cookieKey, railsUrl) {
        var _this = this;
        this.BASE_URL = '/api/v1';
        // N.B. this is a function because `Cookies.get` can change
        // during runtime, we don't want to use the original (or nonexistant)
        // one from JS-load time
        this.commonStack = function () {
            return (0, http_client_1.createStack)((0, http_client_1.init)('credentials', 'include'), (0, http_client_1.accept)('application/json'), (0, http_client_1.header)('Content-Type', 'application/json'), (0, http_client_1.header)('X-CSRF-Token', Cookies.get(cookieKey)), (0, http_client_1.base)(railsUrl));
        };
        // HACK: ES5 ts target mangles the `this` binding
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.keys(this.__proto__).forEach(function (key) {
            _this[key] = _this[key].bind(_this);
        });
    }
    SessionApi.prototype.doWebGet = function (url) {
        return (0, http_client_1.createFetch)(this.commonStack())(url);
    };
    SessionApi.prototype.doWebPost = function (url, jsonParams) {
        var stack = (0, http_client_1.createStack)(this.commonStack(), (0, http_client_1.method)('POST'), (0, http_client_1.json)(jsonParams));
        return (0, http_client_1.createFetch)(stack)(url);
    };
    SessionApi.prototype.doWebPut = function (url, jsonParams) {
        var stack = (0, http_client_1.createStack)(this.commonStack(), (0, http_client_1.method)('PUT'), (0, http_client_1.json)(jsonParams));
        return (0, http_client_1.createFetch)(stack)(url);
    };
    SessionApi.prototype.doWebDelete = function (url) {
        return (0, http_client_1.createFetch)(this.commonStack(), (0, http_client_1.method)('DELETE'))(url);
    };
    SessionApi.prototype.doWebApiGet = function (url, getParams) {
        var stack = (0, http_client_1.createStack)(this.commonStack());
        if (getParams) {
            stack = (0, http_client_1.createStack)(stack, (0, http_client_1.params)(getParams));
        }
        return (0, http_client_1.createFetch)(stack)("".concat(this.BASE_URL).concat(url));
    };
    SessionApi.prototype.handleResponse = function (res) {
        return __awaiter(this, void 0, void 0, function () {
            var responseMessage, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, res.json()];
                    case 1:
                        responseMessage = _a.sent();
                        if (res.ok) {
                            return [2 /*return*/, responseMessage];
                        }
                        errorMessage = "".concat(res.status, " ").concat(res.statusText) +
                            ((responseMessage === null || responseMessage === void 0 ? void 0 : responseMessage.error) ? " ".concat(responseMessage.error) : '');
                        throw new ResponseError(errorMessage, responseMessage);
                }
            });
        });
    };
    // Either email+password, googleIDToken, or email+password+facebookIDToken is required
    //
    // If email+password+facebookIDToken is provided then web will authenticate using
    // the facebook_authenticatable warden strategy. The facebookIDToken should be the accessToken
    // provided from Facebook client-side auth
    // https://developers.facebook.com/docs/facebook-login/web
    //
    // If email+password is provided then web will authenticate using
    // the database_authenticatable warden strategy.
    //
    // If googleIDToken is provided the google_authenticatable strategy is used to authenticate.
    // The googleIDToken should be the OIDC token obtained from Google client-side auth
    // https://developers.google.com/identity/protocols/oauth2/openid-connect#obtainuserinfo
    //
    // For more details on authentication via Web check the devise configuration for the
    // Human model: https://github.com/opendoor-labs/web/blob/7fbaffaf02d03cd75a8ad57c2f1b400dacbb2782/app/models/human.rb
    SessionApi.prototype.logIn = function (email, password, googleIDToken, facebookIDToken) {
        return this.doWebPost('/login', {
            human: { email: email, password: password },
            google_id_token: googleIDToken,
            facebook_id_token: facebookIDToken,
        }).then(this.handleResponse);
    };
    SessionApi.prototype.requestHumanStatus = function (email) {
        return this.doWebApiGet("/humans/status?email=".concat(encodeURIComponent(email))).then(this.handleResponse);
    };
    SessionApi.prototype.requestResetPassword = function (email) {
        return this.doWebPost("".concat(this.BASE_URL, "/humans/reset-password"), { email: email });
    };
    // Either email+password, googleIDToken, or email+password+facebookIDToken is required
    //
    // If email+password+facebookIDToken is provided then web will authenticate using
    // the facebook_authenticatable warden strategy. The facebookIDToken should be the accessToken
    // provided from Facebook client-side auth
    // https://developers.facebook.com/docs/facebook-login/web
    //
    // If email+password is provided then web will authenticate using
    // the database_authenticatable warden strategy.
    //
    // If googleIDToken is provided the google_authenticatable strategy is used to authenticate.
    // The googleIDToken should be the OIDC token obtained from Google client-side auth
    // https://developers.google.com/identity/protocols/oauth2/openid-connect#obtainuserinfo
    // If a user already exists with the provided email then the user will be logged in.
    //
    // For more details on authentication via Web check the devise configuration for the
    // Human model: https://github.com/opendoor-labs/web/blob/7fbaffaf02d03cd75a8ad57c2f1b400dacbb2782/app/models/human.rb
    SessionApi.prototype.register = function (email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
        return this.doWebPost('/register', {
            email: email,
            full_name: name,
            primary_phone: phone,
            password: password,
            google_id_token: googleIDToken,
            facebook_id_token: facebookIDToken,
            passwordless_token: passwordlessToken,
            has_generated_password: hasGeneratedPassword,
            redirect_url: redirectUrl,
        }).then(this.handleResponse);
    };
    SessionApi.prototype.logOut = function () {
        return this.doWebDelete('/logout');
    };
    SessionApi.prototype.fetchSessionInfo = function () {
        return this.doWebGet('/session/info').then(function (res) { return res.json(); });
    };
    SessionApi.prototype.updateHumanInfo = function (humanId, password, name, phone) {
        return this.doWebPut("".concat(this.BASE_URL, "/humans/").concat(humanId), {
            full_name: name,
            primary_phone: phone,
            current_password: password,
        }).then(function (res) { return res.json(); });
    };
    return SessionApi;
}());
exports.SessionApi = SessionApi;
exports["default"] = SessionApi;


/***/ }),

/***/ 11654:
/***/ (function(__unused_webpack_module, exports) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.promptGoogleOneTap = promptGoogleOneTap;
var googleOneTapPromise;
function loadGoogleOneTap() {
    if (!googleOneTapPromise) {
        googleOneTapPromise = new Promise(function (resolve) {
            if (typeof window === 'undefined') {
                return undefined;
            }
            // eslint-disable-next-line no-var
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.defer = true;
            script.src =
                ('https:' === document.location.protocol ? 'https://' : 'http://') +
                    'accounts.google.com/gsi/client';
            script.onload = function () {
                var _a, _b, _c;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var google = window.google;
                if (((_b = (_a = google === null || google === void 0 ? void 0 : google.accounts) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.initialize) && ((_c = google === null || google === void 0 ? void 0 : google.accounts.id) === null || _c === void 0 ? void 0 : _c.prompt)) {
                    resolve(google);
                }
                else {
                    resolve(undefined);
                }
            };
            script.onerror = function () { return resolve(undefined); };
            // Insert our script next to the first script element.
            // eslint-disable-next-line no-var
            var first = document.getElementsByTagName('script')[0];
            // @ts-expect-error fix later
            first.parentNode.insertBefore(script, first);
        });
    }
    return googleOneTapPromise;
}
function promptGoogleOneTap(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var google, reason;
        var analyticsName = _b.analyticsName, clientId = _b.clientId, onSuccess = _b.onSuccess, onPrompted = _b.onPrompted, onDismissed = _b.onDismissed, onSkipped = _b.onSkipped, trackEvent = _b.trackEvent, trackError = _b.trackError;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, loadGoogleOneTap()];
                case 1:
                    google = _c.sent();
                    if (google) {
                        google.accounts.id.initialize({
                            client_id: clientId,
                            callback: function (response) {
                                // @ts-expect-error - Incorrect EventTrackingActions typing with category overrides
                                trackEvent('google-one-tap-success', analyticsName, undefined, {
                                    categoryOverride: 'login',
                                });
                                onSuccess(response);
                            },
                            use_fedcm_for_prompt: true,
                        });
                        google.accounts.id.prompt(function (n) {
                            var momentType = n.getMomentType();
                            if (momentType === 'display') {
                                // @ts-expect-error - Incorrect EventTrackingActions typing with category overrides
                                trackEvent('google-one-tap-displayed', analyticsName, undefined, {
                                    categoryOverride: 'login',
                                });
                                onPrompted && onPrompted(true, undefined);
                            }
                            else if (n.isDismissedMoment()) {
                                trackEvent(
                                // @ts-expect-error - Incorrect EventTrackingActions typing with category overrides
                                'google-one-tap-dismissed', analyticsName, { reason: n.getDismissedReason() }, { categoryOverride: 'login' });
                                onDismissed && onDismissed(n.getDismissedReason());
                            }
                            else if (n.isSkippedMoment()) {
                                // @ts-expect-error - Incorrect EventTrackingActions typing with category overrides
                                trackEvent('google-one-tap-skipped', analyticsName, undefined, {
                                    categoryOverride: 'login',
                                });
                                onSkipped && onSkipped();
                            }
                            else {
                                // google one-tap could not be displayed for multiple reasons now that FedCM is enabled (users can disable one-tap from the browser settings, etc.)
                                // we can not get the exact reason due to privacy restrictions but we can still track when this is not displayed
                                trackError('google-one-tap', new Error('google one tap not displayed'), { reason: 'unknown' }, { skipSentry: true });
                                trackEvent(
                                // @ts-expect-error - Incorrect EventTrackingActions typing with category overrides
                                'google-one-tap-not-displayed', analyticsName, { reason: 'unknown' }, { categoryOverride: 'login' });
                                onPrompted && onPrompted(false, undefined);
                            }
                        });
                    }
                    else {
                        reason = 'script_load_failed';
                        trackError('google-one-tap', new Error('google one tap not displayed'), { reason: reason }, { skipSentry: true });
                        trackEvent(
                        // @ts-expect-error - Incorrect EventTrackingActions typing with category overrides
                        'google-one-tap-not-displayed', analyticsName, { reason: reason }, { categoryOverride: 'login' });
                        onPrompted && onPrompted(false, 'script_load_failed');
                    }
                    return [2 /*return*/];
            }
        });
    });
}


/***/ }),

/***/ 70610:
/***/ (function(module) {


module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ })

}]);